function normalizePaymentName(value) {
  return String(value ?? '').trim().toLowerCase()
}

export function isCashOnDeliveryPayment(payment) {
  if (!payment || typeof payment !== 'object') {
    return false
  }

  return normalizePaymentName(payment.channelKey) === 'cod'
}

export function getSelectedPaymentFromApi(basketPaymentsApi) {
  return basketPaymentsApi?.getSelectedPayment?.() ?? null
}

export function getSelectedPaymentDebugData(basketPaymentsApi) {
  const apiPayment = getSelectedPaymentFromApi(basketPaymentsApi)

  return {
    source: apiPayment ? 'api' : 'none',
    isCashOnDelivery: isCashOnDeliveryPayment(apiPayment),
    apiPayment,
  }
}
